import CONSTANTS from '@/constants'
import { IProductsState } from '@/@types'

const state: IProductsState = {
  passTypes: [],
  availablePlans: [],
  availableCertifications: [],
  availableLiveVirtualTrainings: [],
  liveVirtualTrainingDiscount: 0,
  extensions: [],
  planCodes: Object.values(CONSTANTS.PLANS),
  isOnePlanAvailable: false,
  availableProductBundles: [],
}

export default state
